import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/**
 * 客户管理/客户列表
 * */
import { cloneDeep } from 'lodash';

/**
 * @description 过滤表头
 * @param {Object} columnList 表头原数据
 * @param {Array} showColumns 过滤类型 显示
 * @param {Array} fixedLeftColumns 过滤类型 固定
 */
function filterColumns(columnList, showColumns, fixedLeftColumns) {
  var _columnList = cloneDeep(columnList);
  var lastList = [];
  _columnList.forEach(function (columnItem) {
    var _columnItem = cloneDeep(columnItem);
    if (_columnItem.key !== 'selection' || _columnItem.key !== 'action') {
      if (showColumns && showColumns.length && showColumns.includes(_columnItem.key)) {
        // 2 固定：判断是否存在于过滤条件列表内
        if (fixedLeftColumns && fixedLeftColumns.length && fixedLeftColumns.includes(_columnItem.key)) {
          // 1 显示：判断是否存在于过滤条件列表内
          _columnItem.fixed = 'left';
        }
        lastList.push(_columnItem);
      }
    }
  });
  return lastList;
}
export default {
  namespaced: true,
  state: {
    // 表格表头
    tableColumns: [],
    // 展示的表格列
    showColumns: [],
    // 固定在左侧的表格列
    fixedLeftColumns: [],
    // 表格数据
    tableData: []
  },
  getters: {
    /**
     * @description 根据 显示/冻结 选择，对表格列表显示列/固定列过滤
     * */
    filterShowColumns: function filterShowColumns(state, getters, rootState) {
      var _tableColumns = cloneDeep(state.tableColumns);
      _tableColumns = filterColumns(_tableColumns, state.showColumns, state.fixedLeftColumns);
      return _tableColumns;
    }
  },
  mutations: {
    /**
     * @description 设置表格表头数据
     * @param {Object} state vuex state
     * @param {Array} list list
     */
    setTableColumns: function setTableColumns(state, list) {
      state.tableColumns = list;
    },
    /**
     * @description 设置表格数据
     * @param {Object} state vuex state
     * @param {Array} list list
     */
    setTableData: function setTableData(state, list) {
      state.tableData = list;
    },
    /**
     * @description 设置表格显示列
     * @param {Object} state vuex state
     * @param {Array} keyList keyList
     */
    setShowColumns: function setShowColumns(state, keyList) {
      state.showColumns = keyList;
    },
    /**
     * @description 设置表格左侧固定列
     * @param {Object} state vuex state
     * @param {Array} keyList keyList
     */
    setFixedLColumns: function setFixedLColumns(state, keyList) {
      state.fixedLeftColumns = keyList;
    }
  },
  actions: {
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     * @param {Object} loadOpenedTabs 是否加载页签信息
     */
    load: function load(_ref) {
      var state = _ref.state,
        dispatch = _ref.dispatch;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$loadOpenedTabs = _ref2.loadOpenedTabs,
        loadOpenedTabs = _ref2$loadOpenedTabs === void 0 ? true : _ref2$loadOpenedTabs;
      return new Promise(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch('admin/user/load', null, {
                  root: true
                });
              case 2:
                _context.next = 4;
                return dispatch('admin/page/openedLoad', {
                  loadOpenedTabs: loadOpenedTabs
                }, {
                  root: true
                });
              case 4:
                // end
                resolve();
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }
};